module.exports = __webpack_public_path__ + "whiteoils.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whiteoils.png
// module id = 898
// module chunks = 0